<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import PlusThinIcon from '@amp/web-app-components/assets/icons/plus-thin.svg';
    import IndefiniteSpinner from '@amp/web-app-components/src/components/buttons/IndefiniteSpinner.svelte';

    const dispatch = createEventDispatcher();

    export let translateFn: (
        str: string,
        values?: Record<string, string | number>,
    ) => string;
    export let iconOnly: boolean = false;
    export let showAddedToLibrary: boolean = false;
    export let showAddToLibraryButton: boolean = false;
    export let showSpinner: boolean = false;

    const handleAddClick = async () => dispatch('addClick');
</script>

{#if showAddedToLibrary && !iconOnly}
    <div data-testid="added-to-library" class="added-to-library-flash">
        {translateFn('ASE.Shared.JustAdded')}
    </div>
{:else if showSpinner}
    <div
        class="add-to-library-spinner"
        class:add-to-library-spinner--icon-only={iconOnly}
    >
        <IndefiniteSpinner />
    </div>
{:else if showAddToLibraryButton}
    <button
        class="add-to-library-button"
        class:add-to-library-button--icon-only={iconOnly}
        aria-label={translateFn('AMP.Shared.ContextualMenu.AddToLibrary')}
        title={translateFn('AMP.Shared.ContextualMenu.AddToLibrary')}
        data-testid="add-to-library-button"
        tabindex="0"
        on:click|stopPropagation={handleAddClick}
    >
        <PlusThinIcon />
        {#if !iconOnly}&nbsp;{translateFn('AMP.Shared.Add')}{/if}
    </button>
{/if}

<style lang="scss">
    .add-to-library-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: var(--keyColor);
        cursor: pointer;
        transition: var(--global-transition);

        :global(svg) {
            fill: var(--addToLibraryFillOverride, var(--keyColor));
        }

        &:not(.add-to-library-button--icon-only) {
            height: 100%;
            padding-left: 12px;
            padding-right: 12px;
            column-gap: 3px;
            border-radius: 16px;
            min-width: 64px;
            background-color: var(--systemQuinary);
            font: var(--body-emphasized);
            margin-inline-end: 10px;
        }
    }

    .add-to-library-button--icon-only,
    .add-to-library-spinner--icon-only {
        height: 25px;
        width: 25px;
        line-height: 0; // Normalize white space
        margin-inline-end: 4px;
    }

    .add-to-library-button--icon-only {
        :global(svg) {
            height: 12px;
            width: 12px;
        }
    }

    .added-to-library-flash {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: var(--systemSecondary);
        animation: fadeOut 1s 2s both;
        font: var(--body-emphasized);
        margin-inline-end: 10px;
    }

    .add-to-library-spinner {
        --spinnerFillColor: var(--addToLibraryFillOverride);
        height: 100%;
        display: grid;
        place-items: center;
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }
</style>
